let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("h8XpL")]).then(() => parcelRequire('8SLN8'));